import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { DirectPaymentItem } from '@/api/SE/paymentProvider/types';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import Button from '@/ui-kit/components/Button/Button';
import { DataList, DataListItem, DataListLabel, DataListValue } from '@/ui-kit/components/DataList/DataList';

type ListItemType = {
  title: string;
  value: string;
  valueClass?: string;
  titleClass?: string;
};

type Payload = {
  directPayment: DirectPaymentItem;
};
type Props = ModalProps<Payload>;

const DirectPaymentDetails = ({ closeModal, payload: { directPayment } }: Props) => {
  const { t } = useTranslation(['Modal', 'Button', 'Common', 'DirectPayment']);
  const { items, dueDate } = directPayment;
  const hasDiscount = directPayment.discount > 0;

  const listItems: ListItemType[] = [];

  if (items.credit !== undefined) {
    listItems.push({
      title: t('Common:products.credit'),
      value: t('Common:money', { amount: items.credit }),
    });
  }
  if (items.debtConsolidation !== undefined) {
    listItems.push({
      title: t('Common:products.debtConsolidation'),
      value: t('Common:money', { amount: items.debtConsolidation }),
    });
  }
  if (items.paymentProtectionInsurance !== undefined) {
    listItems.push({
      title: t('Common:products.paymentProtectionInsurance'),
      value: t('Common:money', { amount: items.paymentProtectionInsurance }),
    });
  }
  if (hasDiscount) {
    listItems.push({
      title: t('DirectPayment:Discount.discount'),
      value: `-${t('Common:money', { amount: directPayment.discount })}`,
      titleClass: 'text-text-success',
      valueClass: 'text-text-success',
    });
  }

  return (
    <Modal title={dueDate}>
      <div className="flex flex-col gap-4">
        <p>{hasDiscount ? t('DirectPaymentDetails.discountInfo') : t('DirectPaymentDetails.info')}</p>
        <DataList>
          {listItems.map(({ title, value, valueClass, titleClass }) => (
            <DataListItem key={title}>
              <DataListLabel className={titleClass}>{title}</DataListLabel>
              <DataListValue className={valueClass}>{value}</DataListValue>
            </DataListItem>
          ))}
        </DataList>
        <ModalActions>
          <Button onClick={closeModal}>{t('Button:clear')}</Button>
        </ModalActions>
      </div>
    </Modal>
  );
};

export default DirectPaymentDetails;
